import MicroModal from 'micromodal';
const {KitModule, registerModule} = window;

/**
 * Global event handling for individual Modal elements
 *
 * Emits 'modalshow' and 'modalclose' events when visibility is toggled. These
 * events can be listened for by module scripts that want to customize behavior
 * when a modal is closed or opened. Ensures listeners only receive events for
 * their respective modal elements.
 *
 * @example
 * // ex., _src/_includes/modules/video/video.js
 * this.$modal.addEventListener('modalclose', this.handleModalClose.bind(this));
 *
 * @fires Modal#modalclose
 * @fires Modal#modalshow
 */
class Modal extends KitModule {
    constructor($element) {
        super($element);

        this.bindEvents();
    }

    bindEvents() {
        MicroModal.init({
            onClose: this.handleModalClose.bind(this),
            onShow: this.handleModalShow.bind(this),
            disableScroll: true,
        });
    }

    /**
   * Dispatch a custom 'modalclose' event
   * This can be listened for by a module script to provide custom 'onClose'
   * handling.
   * @param {HTMLElement} $modal
   */
    handleModalClose($modal) {
    // Micromodal invokes onClose callbacks regardless of which modal element
    // was toggled. We compare the firing modal element with the modal element
    // bound to this instance to make sure we invoke the appropriate callback.
        if ($modal === this.$element) {
            const event = new Event('modalclose');
            this.$element.dispatchEvent(event);
        }
    }

    /**
   * Dispatch a custom 'modalshow' event
   * This can be listened for by a module script to provide custom 'onShow'
   * handling.
   * @param {HTMLElement} $modal
   */
    handleModalShow($modal) {
    // Micromodal invokes onShow callbacks regardless of which modal element
    // was toggled. We compare the firing modal element with the modal element
    // bound to this instance to make sure we invoke the appropriate callback.
        if ($modal === this.$element) {
            const event = new Event('modalshow');
            this.$element.dispatchEvent(event);
        }
    }
}

registerModule('Modal', Modal);
